var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contacts section__container"},[_c('hr',{staticClass:"contacts__line"}),_c('Breadcrumbs'),_c('div',{staticClass:"contacts__block"},[_c('Contact',{staticClass:"contacts__block--text"}),_c('FormContact',{staticClass:"contacts__block--form"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }